import { Button, Text, Box, Input } from "@chakra-ui/react"
import WithAuth from "../components/hoc/with-auth"
import { AuthLayout } from "../components/layouts"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx"
import DealsPage from "../components/pages/deals-page"
import OpenPositionsByDaysPage from "../components/pages/open-positions-by-days"

const OpenPositionsByDays = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Open Positions By  Days"
          pageDesc="List of all the current open positions in N number of days"
        >
          <OpenPositionsByDaysPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default OpenPositionsByDays
